import { Box, Paper, Typography } from "@mui/material";
import details from "../../../../../data/details.json";
import HomeHelmet from "../../../../../Helmets/HomeHelmet";

export default function MobileHomePage() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        mt: 10,
      }}
    >
      <HomeHelmet />
      <Paper sx={{ width: "90%" }}>
        <Typography
          variant="h6"
          sx={{ p: 1, fontFamily: '"EB Garamond", serif' }}
        >
          {details.greeter}
        </Typography>
      </Paper>

      <Box sx={{ m: 2 }}>
        <img src="/images/home.jpg" alt="Θεραπευτική γωνιά" width="100%" />
      </Box>
    </Box>
  );
}
